/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动 ID
   */
  event_id: string;
}
/**
 * 发布校验报错项列表
 */
export type Items = {
  /**
   * 报错项类型
   */
  error_type: string;
  /**
   * 报错详细信息
   */
  msg: string;
  /**
   * 报错项优先级，用于排序
   */
  order: number;
  /**
   * 报错分类，1:机器审核不通过 2:发布失败;3:人工审核不通过
   */
  sort: number;
}[];
export interface DashboardEventGetPublishErrorListRes {
  msg: string;
  nonce: string;
  code: string;
  date: Date;
}
export interface Date {
  items: Items;
  /**
   * items的报错中心分类。1:机器审核不通过 2:发布失败;3:人工审核不通过
   */
  items_sort: number;
}

const DashboardEventGetPublishErrorList = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventGetPublishErrorListRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/get-publish-error-list',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventGetPublishErrorList;
